gsap.registerPlugin(Draggable, InertiaPlugin);

var container = document.querySelector('.co-about-s1--media');
var vw = container.offsetWidth + 100;
var vh = container.offsetHeight + container.offsetHeight*0.8;
var th = container.offsetHeight*0.8/2*(-1);

Draggable.create(".co-about-s1--item", {
  bounds: ".co-about-s1--media",
  inertia: true,
  // bounds:{
  //       top: -50,
  //       left: -50,
  //       // width: 100%,
  //       // height: 100%
  //   }
});

const swiperTestimonials = new Swiper('.co-about-s4--slider', {
  // Default parameters
  slidesPerView: 'auto',
  spaceBetween: 4,
  loop: true,
  navigation: {
    nextEl: '.co-about-s4--next',
    prevEl: '.co-about-s4--prev',
  },
})